// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"24":"e229fcaa","380":"ac630cab","506":"b0561418"}[chunkId] + ".js";
};